import React, { useState, useContext, useReducer, useEffect } from 'react';

import reducer from './reducer';

const url = `https://sheltered-badlands-71188.herokuapp.com/api/v1/order/${localStorage.getItem(
  '_id'
)}`;
const AppContext = React.createContext();

const initialState = {
  loading: false,
  cart: [],
  total: 0,
  qty: 0,
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const clearCart = () => {
    dispatch({ type: 'CLEAR_CART' });
  };
  const remove = (_id) => {
    dispatch({ type: 'REMOVE', payload: _id });
  };
  const increase = (_id) => {
    dispatch({ type: 'INCREASE', payload: _id });
  };
  const decrease = (_id) => {
    dispatch({ type: 'DECREASE', payload: _id });
  };
  const fetchData = async () => {
    dispatch({ type: 'LOADING' });
    const response = await fetch(url);
    const cart = await response.json();
    console.log(cart);
    dispatch({ type: 'DISPLAY_ITEMS', payload: cart });
  };
  const toggleAmount = (_id, type) => {
    dispatch({ type: 'TOGGLE_AMOUNT', payload: { _id, type } });
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    dispatch({ type: 'GET_TOTALS' });
  }, [state.cart]);
  return (
    <AppContext.Provider
      value={{
        ...state,
        clearCart,
        remove,
        increase,
        decrease,
        toggleAmount,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
